// Reuse the JavaScript map ID already configured for the business-detail map.
// A map ID selects map configuration; it is not a Google API key.
export const GOOGLE_MAP_ID = '8f348c95f505df06';
